import { render, staticRenderFns } from "./DealersList.vue?vue&type=template&id=8c06723e&scoped=true&"
import script from "./DealersList.vue?vue&type=script&lang=js&"
export * from "./DealersList.vue?vue&type=script&lang=js&"
import style0 from "./DealersList.vue?vue&type=style&index=0&id=8c06723e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c06723e",
  null
  
)

export default component.exports